// Constants for Layout component padding
// Single source of truth for padding values shared between new and legacy code

import theme from '../theme';

export const layoutPadding = {
  desktop: theme.padding.page.desktop,
  mobile: theme.padding.page.mobile,
};
